// extracted by mini-css-extract-plugin
module.exports = {"item":"_3mraZ","category":"yCU_Z"};